import { buildClockworkWebPath } from "lib/resource-finder";

export const redirectToStepUpLogin = () => {
  const urlToStepUp = buildClockworkWebPath(
    "_login/step_up?redirect=" + encodeURIComponent(window.location.href)
  );
  window.location.assign(urlToStepUp);
};
